import Select from 'react-select'

const tagOptions = [
  { value: 'h1', label: 'Heading 1'},
  { value: 'h2', label: 'Heading 2'},
  { value: 'h3', label: 'Heading 3'},
  { value: 'h4', label: 'Heading 4'},
]

const fontOptions = [
  { value: 'Arial, sans-serif', label: 'Arial'},
  { value: 'Helvetica, sans-serif', label: 'Helvetica'},
  { value: 'Optima, sans-serif', label: 'Optima'},
  { value: 'Futura, sans-serif', label: 'Futura'}
]

const HeadingBlockProperties = ({ block }) => {
  const act = useAct()
  const tagValue = tagOptions.find((o) => o.value === block.parameters.tag)
  const fontValue = fontOptions.find((o) => o.value === block.parameters.fontFamily)

  const handleTagChange = (option) => {
    act.email.blocks.updateParameters(block.id, {tag: option.value})
  }

  const handleFontChange = (option) => {
    act.email.blocks.updateParameters(block.id, {fontFamily: option.value})
  }

  return (
    <form>
      <h3 className='no-margin-top'>Edit heading</h3>
      <div className="field">
        <label>Type</label>
        <Select options={tagOptions} value={tagValue} onChange={handleTagChange} classNamePrefix="tag-select" />
      </div>
      <div className="field">
        <label>Font</label>
        <Select options={fontOptions} value={fontValue} onChange={handleFontChange} classNamePrefix="font-select" />
      </div>
    </form>
  )
}
  
 export default HeadingBlockProperties
